import { render, staticRenderFns } from "./ProductsTaged.vue?vue&type=template&id=4d5b496e&scoped=true&"
import script from "./ProductsTaged.vue?vue&type=script&lang=js&"
export * from "./ProductsTaged.vue?vue&type=script&lang=js&"
import style0 from "./ProductsTaged.vue?vue&type=style&index=0&id=4d5b496e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b496e",
  null
  
)

export default component.exports